function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { extractArrayIds, getArrayDifference, isInArray, removeDuplicateObjects } from '@/libs/public';
export default {
  name: '',
  props: {
    // 选中人员数据
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: '请选择人员'
    },
    // 只能单选一个人员
    onlyOne: {
      type: Boolean,
      default: false
    },
    // 开启权限
    role: {
      type: Number,
      default: 0
    },
    // 是否展示人员头像
    isAvatar: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    // 禁用人员名单
    disabledList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      props: {
        children: 'children',
        label: 'label'
      },
      treeHeight: '',
      filterText: '',
      selectIds: [],
      showPopover: false,
      userList: [],
      //选中的人员数据
      userIds: [],
      //选中的人员的id
      selectList: [],
      leave: 0,
      isSlots: false,
      treeData: []
    };
  },
  computed: {},
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    },
    value: function value(newVal, oldValue) {
      if (this.value.length > 0) {
        this.userList = this.value;
        this.userIds = extractArrayIds(this.userList, this.userList[0].id ? 'id' : 'value');
        this.selectIds = this.findNamesByIds(this.treeData, this.userIds);
        this.$refs.tree.setCheckedKeys(this.selectIds);
      } else {
        this.userList = [];
        this.userIds = [];
        this.selectIds = [];
        this.$refs.tree.setCheckedKeys([]);
      }
    }
  },
  mounted: function mounted() {
    document.addEventListener('click', this.handleGlobalClick);
    // 判断是否有插槽内容
    if (this.$slots.custom) {
      this.isSlots = true;
    }
    this.getTreeData();
    if (this.value.length > 0) {
      this.userList = this.value;
      this.userIds = extractArrayIds(this.userList, this.userList[0].id ? 'id' : 'value');
      this.selectIds = this.findNamesByIds(this.treeData, this.userIds);
    }
  },
  methods: {
    cardTag: function cardTag(index) {
      this.userList.splice(index, 1);
      this.$emit('getSelectList', this.userList);
    },
    // 多选
    depCheck: function depCheck(data, status) {
      if (data.user_count === 0) {
        return false;
      }
      if (this.disabledList.includes(data.value)) {
        return this.$message.warning('此人员已加入其他考勤组');
      }
      // 选择成员
      var arr = this.getDepartmentDataById(data, data.value);
      // 点击选中
      if (isInArray(status.checkedKeys, data.id)) {
        var _this$userList;
        (_this$userList = this.userList).push.apply(_this$userList, _toConsumableArray(arr));
        // 根据id过滤重复成员
        this.userList = removeDuplicateObjects(this.userList, 'value');
      } else {
        // 数组去差集
        this.userList = getArrayDifference(this.userList, arr, 'value');
      }
      this.userIds = extractArrayIds(this.userList, 'value');
      this.selectIds = this.findNamesByIds(this.treeData, this.userIds);
      this.$refs.tree.setCheckedKeys(this.selectIds);
      this.$emit('getSelectList', this.userList);
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 选中人员单选
    checkUser: function checkUser(user) {
      if (user.type == 0) return false;
      if (this.disabledList.includes(user.value)) {
        return this.$message.warning('此人员已加入其他考勤组');
      }
      if (!this.onlyOne) {
        return;
      }
      if (isInArray(this.userIds, user.value)) {
        return this.$message.warning('已选中该成员');
      }
      this.userList = [];
      this.userList.push(user);
      this.userIds = extractArrayIds(this.userList, 'value');
      this.userList = removeDuplicateObjects(this.userList);
      this.$emit('getSelectList', this.userList);
      this.$refs.treePopover.doClose();
    },
    handleGlobalClick: function handleGlobalClick(event) {
      if (!this.$refs.treePopover.$el.contains(event.target)) {
        this.showPopover = false;
      }
    },
    handlePopoverShow: function handlePopoverShow() {
      this.showPopover = true;
    },
    handlePopoverHide: function handlePopoverHide() {
      this.showPopover = false;
    },
    getTreeData: function getTreeData() {
      this.treeData = this.$store.state.user.memberList;
      this.selectIds = this.findNamesByIds(this.treeData, this.userIds);
    },
    /**
     * 递归获取某部门所有成员
     * @param {Object} data  初始数据
     * @param {Number} deptId 部门id
     * @returns {*[]}
     */
    getDepartmentDataById: function getDepartmentDataById(data, deptId) {
      var department = data;
      if (department) {
        // 递归函数，用于遍历子部门和用户
        var _traverseChildren = function traverseChildren(children) {
          children.forEach(function (child) {
            if (child.children) {
              _traverseChildren(child.children);
            } else {
              members.push(child);
            }
          });
        };
        var members = [];
        _traverseChildren([department]);
        return members;
      }
      return [];
    },
    findNamesByIds: function findNamesByIds(tree, id) {
      var ids = id.map(function (str) {
        return parseInt(str);
      });
      var result = [];
      function traverse(node) {
        if (ids.includes(node.value) && node.type != 0) {
          result.push(node.id);
        }
        if (node.children) {
          var _iterator = _createForOfIteratorHelper(node.children),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var child = _step.value;
              traverse(child);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
      var _iterator2 = _createForOfIteratorHelper(tree),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var node = _step2.value;
          traverse(node);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return result;
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick);
  }
};